import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { PopularHotelsDestinationsItem } from './PopularHotelsDestinationsItem';
import { LocationHotelsSuppliers } from '../../models';
import { Div } from '../../layouts';
import { withTrackComponentDisplayed } from '../../utils/HtmlEvents';

const classPopularDestTitle = 'odf-strong odf-space-inner-top-m odf-space-inner-bottom-m odf-space-inner-right-l odf-space-inner-left-xl';

const TOP_DESTINATION_DISPLAYED = 'hotel-standalone-search-popular-destination';
const PopularHotelsDestinationsDesktop = withTrackComponentDisplayed(({
    show,
    onClickItem,
}) => {
    const { t } = useTranslation();
    const topHotelsDestinationsCMS = t('home.hsaSearch.popularDestinationsValue', { returnObjects: true });
    const topHotelsDestinationsArr = topHotelsDestinationsCMS.startsWith('[')
        ? JSON.parse(topHotelsDestinationsCMS.replace(/\n/g, '').replace(/'/g, '"'))
        : [];

    const topDestinationsToRender = topHotelsDestinationsArr.map((val) => ({
        ...val,
        'geoNodeId': null,
        'geoNodeIdSupplier': LocationHotelsSuppliers.HSA,
        'countryCode': '',
    }));

    if (!show || topDestinationsToRender.length === 0) {
        return <></>;
    }
    return (
        <>
            <Div className={classPopularDestTitle} whiteSpace="normal">
                {t('home.hsaSearch.popularDestinations')}
            </Div>
            { topDestinationsToRender.map((item, i) => (
                <PopularHotelsDestinationsItem
                    key={item.id}
                    index={i}
                    item={item}
                    onClickItem={onClickItem}
                />
            ))}
        </>
    );
}, TOP_DESTINATION_DISPLAYED);

PopularHotelsDestinationsDesktop.propTypes = {
    onClickItem: PropTypes.func.isRequired,
    show: PropTypes.bool,
};

PopularHotelsDestinationsDesktop.defaultProps = {
    show: true,
};

export { PopularHotelsDestinationsDesktop };
